import { css } from 'linaria';

export const utpCardsContainer = css`
  display: flex;
  column-gap: 28px;
  width: 100%;

  @media (--to-desktop) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
`;

export const utpCard = css`
  border-radius: var(--rounding-xl);
  background-color: var(--background-secondary);
  padding: 20px 10px;
  flex: 1;
  text-align: center;
  display: flex;
  flex-direction: column;
`;

export const utpCardText = css`
  margin-bottom: 4px;

  &&& {
    @media (--from-tablet) and (--to-largeDesktop) {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;
